/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/customer_appCommonService";
import supplierItemService from "../../../services/supplier_appCommonService";
import customerV2temService from "../../../services/customer_v2_appCommonService";

const initialState = {
  data: [],
  category_selection: {
    data: [],
    status: true,
  },
  selectedCategory: [],
  status: true,
  customerID: "",
  customerWorkflow: {},
  accountGroup: "",
  pagination: {
    page: "",
    per_page: "",
    total: "",
  },
  indent: {
    indentNumber: "",
    selectedIndentRows: [],
  },
  rfq: {
    data: [],
    status: true,
    rfxNr: "",
    rfqSupplierID: "",
    workflowTECH: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  quotation: {
    data: [],
    status: true,
    rfxNr: "",
    quotationListInfo: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  purchaseOrder: {
    data: [],
    status: true,
    purchaseOrderNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  invoice: {
    data: [],
    status: true,
    invoiceNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  purchase: {
    data: [],
    status: true,
    purchaseNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  bankStatement: {
    data: [],
    status: true,
    bankStatements: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  cashRequest: {
    data: [],
    status: true,
    cashRequestNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  cashExpenses: {
    data: [],
    status: true,
    cashExpensesNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  employee: {
    data: [],
    status: true,
    employeeNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  ledgers: {
    data: [],
    status: true,
    step: 1,
    ledgersFilter: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    addCategorySelectedData(state, action) {
      state.selectedCategory = action.payload || [];
    },
    addcustomerID(state, action) {
      state.customerID = action.payload;
    },
    workflow(state, action) {
      state.customerWorkflow = action.payload;
    },
    addAccountGroup(state, action) {
      state.accountGroup = action.payload;
    },
    addSelectedRows(state, action) {
      state.indent.selectedIndentRows = action.payload;
    },
    addRfxNr(state, action) {
      state.rfq.rfxNr = action.payload;
    },
    rfqSupplierID(state, action) {
      state.rfq.rfqSupplierID = action.payload;
    },
    addRfqCreation(state, action) {
      state.rfqCreation = action.payload;
    },
    quotationListInfo(state, action) {
      state.quotation.quotationListInfo = action.payload;
    },
    addPurchaseOrder(state, action) {
      state.purchaseOrder.purchaseOrderNr = action.payload;
    },
    createQuotation(state, action) {
      state.quotation.rfxNr = action.payload;
    },
    invoiceNr(state, action) {
      state.invoice.invoiceNr = action.payload;
    },
    purchaseNr(state, action) {
      state.purchase.purchaseNr = action.payload;
    },
    bankStatements(state, action) {
      state.bankStatement.bankStatements = action.payload;
    },
    cashRequestNr(state, action) {
      state.cashRequest.cashRequestNr = action.payload;
    },
    cashExpensesNr(state, action) {
      state.cashExpenses.cashExpensesNr = action.payload;
    },
    employeeNr(state, action) {
      state.employee.employeeNr = action.payload;
    },
    updateLedgerFilter(state, action) {
      const newData = action.payload;
      if (state.ledgers.ledgersFilter.length === 0) {
        // First time, push the object
        state.ledgers.ledgersFilter.push(newData);
      } else {
        // Merge new data into the existing first object
        state.ledgers.ledgersFilter[0] = {
          ...state.ledgers.ledgersFilter[0],
          ...newData,
        };
      }
    },
    updateStep(state, action) {
      state.ledgers.step = action.payload; // ✅ update step under Ledgers
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerList.pending, (state, action) => {
        state.status = true;
      })
      .addCase(getCustomerList.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.pagination.page = action.payload.page;
        state.pagination.per_page = action.payload.per_page;
        state.pagination.total = action.payload.total;
        state.status = false;
      })
      .addCase(getCustomerCategorySelection.fulfilled, (state, action) => {
        state.category_selection.data = action.payload;
        state.status = false;
      })

      .addCase(customerGetRfqQuotation.pending, (state, action) => {
        state.rfq.status = true;
      })
      .addCase(customerGetRfqQuotation.fulfilled, (state, action) => {
        state.rfq.data = action.payload.data;
        state.rfq.pagination.page = action.payload.page;
        state.rfq.pagination.per_page = action.payload.per_page;
        state.rfq.pagination.total = action.payload.total;
        state.rfq.status = false;
      })
      .addCase(getRfqleList.pending, (state, action) => {
        state.rfq.status = true;
      })
      .addCase(getRfqleList.fulfilled, (state, action) => {
        state.rfq.data = action.payload.data;
        state.rfq.pagination.page = action.payload.page;
        state.rfq.pagination.per_page = action.payload.per_page;
        state.rfq.pagination.total = action.payload.total;
        state.rfq.status = false;
      })
      .addCase(getQuotation.pending, (state, action) => {
        state.quotation.status = true;
      })
      .addCase(getQuotation.fulfilled, (state, action) => {
        state.quotation.data = action.payload.data;
        state.quotation.pagination.page = action.payload.page;
        state.quotation.pagination.per_page = action.payload.per_page;
        state.quotation.pagination.total = action.payload.total;
        state.quotation.status = false;
      })
      .addCase(getPurchaseOrderCustomerV2.pending, (state, action) => {
        state.purchaseOrder.status = true;
      })
      .addCase(getPurchaseOrderCustomerV2.fulfilled, (state, action) => {
        state.purchaseOrder.data = action.payload.data;
        state.purchaseOrder.pagination.page = action.payload.page;
        state.purchaseOrder.pagination.per_page = action.payload.per_page;
        state.purchaseOrder.pagination.total = action.payload.total;
        state.purchaseOrder.status = false;
      })
      .addCase(getRfqQuotation.pending, (state, action) => {
        state.rfq.status = true;
      })
      .addCase(getRfqQuotation.fulfilled, (state, action) => {
        state.rfq.data = action.payload.data;
        state.rfq.pagination.page = action.payload.page;
        state.rfq.pagination.per_page = action.payload.per_page;
        state.rfq.pagination.total = action.payload.total;
        state.rfq.status = false;
      })
      .addCase(getCustomerV2Invoice.pending, (state, action) => {
        state.invoice.status = true;
      })
      .addCase(getCustomerV2Invoice.fulfilled, (state, action) => {
        state.invoice.data = action.payload.data;
        state.invoice.pagination.page = action.payload.page;
        state.invoice.pagination.per_page = action.payload.per_page;
        state.invoice.pagination.total = action.payload.total;
        state.invoice.status = false;
      })
      .addCase(getPurchaseList.pending, (state, action) => {
        state.purchase.status = true;
      })
      .addCase(getPurchaseList.fulfilled, (state, action) => {
        state.purchase.data = action.payload.data;
        state.purchase.pagination.page = action.payload.page;
        state.purchase.pagination.per_page = action.payload.per_page;
        state.purchase.pagination.total = action.payload.total;
        state.purchase.status = false;
      })
      .addCase(getBankStatement.pending, (state, action) => {
        state.bankStatement.status = true;
      })
      .addCase(getBankStatement.fulfilled, (state, action) => {
        state.bankStatement.data = action.payload.data;
        state.bankStatement.pagination.page = action.payload.page;
        state.bankStatement.pagination.per_page = action.payload.per_page;
        state.bankStatement.pagination.total = action.payload.total;
        state.bankStatement.status = false;
      })
      .addCase(getCashRequest.pending, (state, action) => {
        state.cashRequest.status = true;
      })
      .addCase(getCashRequest.fulfilled, (state, action) => {
        state.cashRequest.data = action.payload.data;
        state.cashRequest.pagination.page = action.payload.page;
        state.cashRequest.pagination.per_page = action.payload.per_page;
        state.cashRequest.pagination.total = action.payload.total;
        state.cashRequest.status = false;
      })
      .addCase(getCashExpenses.pending, (state, action) => {
        state.cashExpenses.status = true;
      })
      .addCase(getCashExpenses.fulfilled, (state, action) => {
        state.cashExpenses.data = action.payload.data;
        state.cashExpenses.pagination.page = action.payload.page;
        state.cashExpenses.pagination.per_page = action.payload.per_page;
        state.cashExpenses.pagination.total = action.payload.total;
        state.cashExpenses.status = false;
      })
      .addCase(getEmployeeList.pending, (state, action) => {
        state.employee.status = true;
      })
      .addCase(getEmployeeList.fulfilled, (state, action) => {
        state.employee.data = action.payload.data;
        state.employee.pagination.page = action.payload.page;
        state.employee.pagination.per_page = action.payload.per_page;
        state.employee.pagination.total = action.payload.total;
        state.employee.status = false;
      })
      .addCase(getLedgerList.pending, (state, action) => {
        state.ledgers.status = true;
      })
      .addCase(getLedgerList.fulfilled, (state, action) => {
        state.ledgers.data = action.payload.data;
        state.ledgers.pagination.page = action.payload.page;
        state.ledgers.pagination.per_page = action.payload.per_page;
        state.ledgers.pagination.total = action.payload.total;
        state.ledgers.status = false;
      });
  },
});

export const {
  addCategorySelectedData,
  addcustomerID,
  addAccountGroup,
  workflow,
  addSelectedRows,
  addRfxNr,
  rfqSupplierID,
  addRfqCreation,
  quotationListInfo,
  addPurchaseOrder,
  createQuotation,
  invoiceNr,
  purchaseNr,
  updateLedgerFilter,
  updateStep,
  bankStatements,
  cashRequestNr,
  cashExpensesNr,
  employeeNr,
} = customerSlice.actions;
export default customerSlice.reducer;

export const getCustomerList = createAsyncThunk(
  "getCustomerList",
  async (param) => {
    console.log(">> loaded getCustomerList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  }
);
export const getCustomerCategorySelection = createAsyncThunk(
  "getCustomerCategorySelection",
  async () => {
    console.log(">> loaded getCustomerCategorySelection");
    const res = await ItemService.getCustomerCategorySelection();
    return res.data;
  }
);

export const customerGetRfqQuotation = createAsyncThunk(
  "customerGetRfqQuotation",
  async (param) => {
    console.log(">> loaded customerGetRfqQuotation");
    const res = await supplierItemService.getRfqQuotation(param);
    return res;
  }
);
export const getRfqleList = createAsyncThunk("getRfqleList", async (param) => {
  console.log(">> loaded getRfqleList");
  const res = await ItemService.generateCustomerQuery(param);
  return res;
});
export const getQuotation = createAsyncThunk("getQuotation", async (param) => {
  console.log(">> loaded getQuotation");
  const res = await customerV2temService.generateCustomerQuery(param);
  return res;
});
export const getPurchaseOrderCustomerV2 = createAsyncThunk(
  "getPurchaseOrderCustomerV2",
  async (param) => {
    console.log(">> loaded getPurchaseOrderCustomerV2");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);
export const getRfqQuotation = createAsyncThunk(
  "getRfqQuotation",
  async (param) => {
    console.log(">> loaded getRfqQuotation ");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);
export const getCustomerV2Invoice = createAsyncThunk(
  "getCustomerV2Invoice",
  async (param) => {
    console.log(">> loaded getCustomerV2Invoice ");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);
export const getPurchaseList = createAsyncThunk(
  "getPurchaseList",
  async (param) => {
    console.log(">> loaded getPurchaseList ");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);
export const getBankStatement = createAsyncThunk(
  "getBankStatement",
  async (param) => {
    console.log(">> loaded getBankStatement ");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);
export const getCashRequest = createAsyncThunk(
  "getCashRequest",
  async (param) => {
    console.log(">> loaded getCashRequest ");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);

export const getCashExpenses = createAsyncThunk(
  "getCashExpenses",
  async (param) => {
    console.log(">> loaded getCashExpenses ");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);

export const getEmployeeList = createAsyncThunk(
  "getEmployeeList",
  async (param) => {
    console.log(">> loaded getEmployeeList ");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);
export const getLedgerList = createAsyncThunk(
  "getLedgerList",
  async (param) => {
    console.log(">> loaded getLedgerList ");
    const res = await customerV2temService.generateCustomerQuery(param);
    return res;
  }
);
